module.exports = __webpack_public_path__ + "img/step.3379a2b0.png";